"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AminoConverter = void 0;
exports.AminoConverter = {
    "/cosmos.bank.v1beta1.MsgSend": {
        aminoType: "cosmos-sdk/MsgSend",
        toAmino: ({ fromAddress, toAddress, amount }) => {
            return {
                from_address: fromAddress,
                to_address: toAddress,
                amount: amount.map(el0 => ({
                    denom: el0.denom,
                    amount: el0.amount
                }))
            };
        },
        fromAmino: ({ from_address, to_address, amount }) => {
            return {
                fromAddress: from_address,
                toAddress: to_address,
                amount: amount.map(el0 => ({
                    denom: el0.denom,
                    amount: el0.amount
                }))
            };
        }
    },
    "/cosmos.bank.v1beta1.MsgMultiSend": {
        aminoType: "cosmos-sdk/MsgMultiSend",
        toAmino: ({ inputs, outputs }) => {
            return {
                inputs: inputs.map(el0 => ({
                    address: el0.address,
                    coins: el0.coins.map(el1 => ({
                        denom: el1.denom,
                        amount: el1.amount
                    }))
                })),
                outputs: outputs.map(el0 => ({
                    address: el0.address,
                    coins: el0.coins.map(el1 => ({
                        denom: el1.denom,
                        amount: el1.amount
                    }))
                }))
            };
        },
        fromAmino: ({ inputs, outputs }) => {
            return {
                inputs: inputs.map(el0 => ({
                    address: el0.address,
                    coins: el0.coins.map(el1 => ({
                        denom: el1.denom,
                        amount: el1.amount
                    }))
                })),
                outputs: outputs.map(el0 => ({
                    address: el0.address,
                    coins: el0.coins.map(el1 => ({
                        denom: el1.denom,
                        amount: el1.amount
                    }))
                }))
            };
        }
    }
};
//# sourceMappingURL=tx.amino.js.map